import { Plugin } from "..";
import { defaultDynamicImageDataOptions } from "./dynamic-image-data-options";

const id = "dynamic-image";

export const DynamicImage: Plugin = {
	id,
	type: "cursor",
	header: {
		visible: true,
		edit: true,
		fullscreen: true,
	},
	name: "dynamicImage",
	component: defineAsyncComponent(() => import("./DynamicImagePlugin.vue")),
	config: defineAsyncComponent(() => import("./DynamicImagePluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./DynamicImageDataConfig.vue")),
	defaultDataResolver: () => defaultDynamicImageDataOptions,
	defaultOptionsResolver: () => undefined,
	dimension: {
		minHeight: 4,
		minWidth: 4,
	},

	currentVersion: 1,
	migrations: {},
};
